import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_posts_toolbar_btn = _resolveComponent("posts-toolbar-btn")!
  const _component_posts_toolbar = _resolveComponent("posts-toolbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'lt-lg': _ctx.minimized, 'gt-md': !_ctx.minimized})
  }, [
    (_ctx.minimized)
      ? (_openBlock(), _createBlock(_component_posts_toolbar_btn, _mergeProps({
          key: 0,
          filters: _ctx.filters
        }, _ctx.maximizeBtn, {
          "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:filters', $event)))
        }), {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["filters"]))
      : (_openBlock(), _createBlock(_component_posts_toolbar, {
          key: 1,
          filters: _ctx.filters,
          "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:filters', $event)))
        }, {
          append: _withCtx(() => [
            _renderSlot(_ctx.$slots, "append")
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["filters"]))
  ], 2))
}